import React from 'react'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid'

const MailFooterInfoBoard = ({appType, mailFooter, memberType, activeApp}) => {
    const recipientOpt = mailFooter.recipients[appType]
    const infoActive = recipientOpt.requester || recipientOpt.provider
    let memberText = ''
    if(!mailFooter.isActive || !infoActive) {
        return null
    }
 
    if(mailFooter.isActive && appType==='pflegekasse') {
   
            memberText = recipientOpt.requester
            ? recipientOpt.provider
                ? 'Bedarf & Helfer'
                : 'Bedarf'
            : recipientOpt.provider
                ? 'Helfer'
                : ''
                
    } else {
        memberText = recipientOpt.requester
        ? recipientOpt.provider
            ? 'Bedarf & Helfer'
            : 'Bedarf'
        : recipientOpt.provider
            ? 'Helfer'
            : ''
    }

  return (
    <Card raised 
        style={{
            marginTop: '8px',
            marginBottom: '8px',
            padding: '0 8px 0 8px',
            backgroundColor: 'red',
            color: 'white',
            fontWeight: 'bold' 
        }}>
            <Grid container>
                <Grid item md={5}>
                    <Typography  component='span' variant='subtitle1'>E-Mail Footer aktiv für {memberText}</Typography>
                </Grid>
                <Grid item md={2} style={{}}>
                    <Button style={{color: 'white'}} size='small' component={Link} to='/einstellungen/mail_anhang'  >Ändern</Button>
                </Grid>
            </Grid>
    </Card>
  )
}

export default connect((state) => {
	return ({
		mailFooter: state.mailFooter,
        activeApp:    state.user.settings.activeApp
  	})
})(MailFooterInfoBoard)


